import * as React from "react";

// MUI
import { Button, ButtonProps, CircularProgress } from "@material-ui/core";
import {
	withStyles,
	WithStyles,
	Theme,
	createStyles,
} from "@material-ui/core/styles";
import Utility from "../../domain/classes/Utility";

// Utility

export const styles = (theme: Theme) =>
	createStyles({
		root: { width: "100%", position: "relative" },
		loader: {
			position: "absolute",
			top: "50%",
			left: "50%",
			marginLeft: -12,
			marginTop: -12,
		},
	});

export interface LoadingButtonProps extends ButtonProps {
	isLoading: boolean;
}

const LoadingButton = React.forwardRef<
	HTMLDivElement,
	LoadingButtonProps & WithStyles<typeof styles>
>(
	(
		{
			children,
			type,
			classes,
			isLoading,
			fullWidth,
			onClick,
			...buttonProps
		},
		ref
	) => {
		return (
			<div className={classes.root} ref={ref}>
				<Button
					variant="contained"
					color="primary"
					fullWidth={fullWidth}
					disabled={isLoading}
					type={type}
					onClick={onClick}
					{...buttonProps}
				>
					{children}
				</Button>
				{isLoading && (
					<CircularProgress
						className={classes.loader}
						color="primary"
						size={24}
					/>
				)}
			</div>
		);
	}
);

export default withStyles(styles, {
	name: Utility.generateClassName("LoadingButton"),
})(LoadingButton);
